// Red Flag: its lists that open by address. No React in here.
//
// Red Flags Today counts PEOPLE, one row each however many flags they got. The dashboard
// counts three periods: the trend is the month picked, the Leaderboard the calendar
// year, Red Flags Today today.
import type { DashboardListInfo } from './types';

export const RED_FLAG_LIST = { flaggedToday: 'flagged-today', leaderboard: 'leaderboard' } as const;

export const LISTS: DashboardListInfo[] = [
  { slug: RED_FLAG_LIST.flaggedToday, name: 'Red Flags Today', line: 'Everyone flagged today, with the rule that fired.', keywords: 'flagged today' },
  { slug: RED_FLAG_LIST.leaderboard, name: 'Red Flag Leaderboard', line: 'The people with the most red flags. Counts the whole calendar year.', keywords: 'most flagged repeat' },
];
